<template>
  <div class="app-content" :style="{width: computedWidth+'px', height: computedHeight+'px'}">
    <div style="margin: 12px 0;width: 100%;height: 40px;border-bottom: 0.5px solid gainsboro;">
      <div style="float: left; margin-bottom: 12px">
        <el-button size="mini" :disabled="checkRow.length===0" type="primary" @click="cancelShare" icon="el-icon-cus-cancel1">取消分享</el-button>
        <!--<span style="font-size: 13px; padding: 10px;">温馨提示：分享失败超过一年的记录将被清理哦～</span>-->
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%" :highlight-current-row="true" @selection-change="handleSelectionChange" @cell-mouse-enter="hoverFileName"
              @cell-mouse-leave="leaveFileName" :height="computedHeight-55">
      <el-table-column align="left" type="selection" width="55"></el-table-column>
      <el-table-column align="left" label="分享文件" width="200">
        <template slot-scope="scope">
          <div>
            <el-button type="text" @click="clickFileName(scope.row)" :style="{color: scope.row.fontColor}" :icon="scope.row.icon" class="too-long user-select">{{scope.row.shareName}}</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" width="70px">
        <template slot-scope="scope" v-if="showMenuBar">
          <div class="btn-operate">
            <el-button type="text" size="mini" icon="el-icon-cus-cancel1" class="icon-more" :style="{color: scope.row.iconColor}" @click="cancelShare(scope.row)"></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="left" width="70px">
        <template slot-scope="scope">
          <el-popover trigger="click">
            <p v-if="scope.row.password">链接: {{ scope.row.url }} 提取码: {{scope.row.password}}</p>
            <p v-else>链接: {{ scope.row.url }}</p>
            <el-button type="primary" size="mini" @click="clickCopyLink(scope.row)">点击复制</el-button>
            <div slot="reference" class="name-wrapper">
              <div class="btn-operate">
                <el-button type="text" size="mini" icon="el-icon-info" class="icon-more" :style="{color: scope.row.iconColor}"></el-button>
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="viewTimes" label="浏览次数" width="120"> </el-table-column>
      <el-table-column align="left" prop="downloadTimes" label="下载次数" width="120"> </el-table-column>
      <el-table-column align="left" prop="createDT" label="分享时间" width="180"> </el-table-column>
      <el-table-column align="left" prop="expireTime" label="过期时间" width="180"> </el-table-column>
      <!--<el-table-column align="left" prop="availableFlag" label="分享是否可用" width="120" :formatter="formatterAvailable"> </el-table-column>-->
      <el-table-column align="left" prop="downloadFlag" label="需要后登录才能下载文件" width="180" :formatter="formatterDownload"> </el-table-column>
      <el-table-column align="left" prop="comment" label="备注说明" width="280"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import ct from '../../utils/constant.js'
export default {
  created () {
    this.getTableData()
  },
  mounted () {
  },
  data () {
    return {
      tableData: [],
      checkRow: [],
      params: {
        startIndex: 0,
        pageSize: 1000,
        orderColumn: 'createDT',
        isDesc: true
      },
      fontColor: '#303133',
      iconColor: '#303133'
    }
  },
  components: {
  },
  methods: {
    ...mapMutations(['']),
    handleSelectionChange (sel) {
      this.checkRow = sel
    },
    getTableData () {
      this.postRequest('loadMySharingFiles', this.params).then(res => {
        if (res.data.code === 0) {
          this.tableData = this.tableDataHandler(res.data.result)
        }
        // console.log('loadMySharingFiles', res)
      })
    },
    tableDataHandler (data) {
      let res = []
      data.forEach(e => {
        let obj = {}
        obj.fontColor = this.fontColor
        obj.iconColor = this.iconColor
        obj.shareGUID = e.shareGUID
        obj.shareName = e.shareName
        obj.viewTimes = e.viewTimes
        obj.downloadTimes = e.downloadTimes
        obj.createDT = e.createDT
        obj.expireTime = e.expireTime
        obj.availableFlag = e.availableFlag
        obj.downloadFlag = e.downloadFlag
        obj.comment = e.comment
        obj.url = e.url
        obj.password = e.password
        res.push(obj)
      })
      return res
    },
    formatterAvailable (row) {
      return this.getStorage('dictBoolean')[row.availableFlag]
    },
    formatterDownload (row) {
      return this.getStorage('dictBoolean')[row.downloadFlag]
    },
    cancelShare (row) {
      this.$confirm('确认取消分享吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        if (!row.shareGUID) {
          row = this.checkRow
        } else {
          row = [row]
        }
        let guids = []
        row.forEach(e => {
          guids.push(e.shareGUID)
        })
        this.postRequest('cancelSharingFiles', {shareGUIDs: guids}).then(res => {
          if (res.data.code === 0) {
            this.$message({message: '取消成功～', type: 'success'})
            this.cancelShareHandler(row)
          }
        })
      }).catch(() => {})
    },
    cancelShareHandler (row) {
      let list = this.tableData
      row.forEach(f => {
        list = list.filter(l => l.shareGUID !== f.shareGUID)
      })
      this.tableData = list
    },
    clickFileName (row) {
      this.$router.push({name: ct.RouterData.shared.name, query: {id: row.shareGUID}, params: {updateCode: Math.random() * 1000}})
    },
    hoverFileName (row) {
      row.fontColor = '#409EFF'
      row.iconColor = '#409EFF'
    },
    leaveFileName (row) {
      row.fontColor = '#303133'
      row.iconColor = 'gray'
    },
    clickCopyLink (row) {
      let str = row.password ? '链接：' + row.url + '，提取码：' + row.password : '链接：' + row.url
      this.$copyText(str).then((e) => {
        this.$message({message: '复制成功，快去发送给好友吧～', type: 'success'})
      })
    }
  },
  computed: {
    ...mapState(['computedWidth', 'computedHeight']),
    showMenuBar () {
      return this.checkRow.length < 2
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/netDisk/MyShare.vue